export default __webpack_public_path__ + "static/media/ee1.d3eb2c70.png";